import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import courseActions from '@redux/course/actions';
import { RootState } from '@redux/reducer';

const { fetchCourseReviewListAction } = courseActions;

export type FetchCourseReviewListRequestPagination = {
  page: number;
};

export const COURSE_REVIEW_DEFAULT_PAGE = 1;
export const COURSE_REVIEW_LIST_PAGE_SIZE = 3;

type UseCourseReviewListingProps = {
  idName?: string;
};

export const useCourseReviewListing = ({ idName }: UseCourseReviewListingProps) => {
  const dispatch = useDispatch();

  const { courseReviewListState } = useSelector((state: RootState) => ({
    courseReviewListState: state.Course.get('courseReviewListState'),
  }));

  const handleResetCourseReviewList = () => {
    dispatch(fetchCourseReviewListAction.reset());
  };

  const handleFetchCourseReviewList = useCallback(
    (values: FetchCourseReviewListRequestPagination) => {
      if (!idName) {
        return;
      }

      dispatch(
        fetchCourseReviewListAction.request({
          courseIdOrIdName: idName,
          limit: COURSE_REVIEW_LIST_PAGE_SIZE,
          offset: values.page * COURSE_REVIEW_LIST_PAGE_SIZE - COURSE_REVIEW_LIST_PAGE_SIZE,
        }),
      );
    },
    [dispatch, idName],
  );

  const {
    data: courseReviewListData,
    error: courseReviewListDataError,
    isLoading: isCourseReviewListDataLoading,
    isError: isCourseReviewListDataError,
    isSuccess: isCourseReviewListDataSuccess,
  } = courseReviewListState;

  return {
    handleFetchCourseReviewList,
    courseReviewListData,
    courseReviewListDataError,
    isCourseReviewListDataLoading,
    isCourseReviewListDataError,
    isCourseReviewListDataSuccess,
    courseReviewListPage: courseReviewListData?.page ?? COURSE_REVIEW_DEFAULT_PAGE,
    handleResetCourseReviewList,
  };
};
